// React Dependencies
import React from 'react';

// Extenral Dependencies
import PropTypes from 'prop-types';
import { Checkbox, Typography } from '@material-ui/core';

const ScreenTakeOver = ({ isChecked, setIsChecked }) => (
  <div>
    <div className="d-flex align-items-center">
      <Typography
        style={{ fontSize: '14px', fontWeight: 500, margin: 0 }}
        variant="body1"
        color="inherit"
      >
        Display this ad as a home-screen take-over
      </Typography>
      <Checkbox checked={isChecked} onChange={(e) => setIsChecked(e.target.checked)} />
    </div>
  </div>
);
export default ScreenTakeOver;

ScreenTakeOver.propTypes = {
  isChecked:    PropTypes.bool.isRequired,
  setIsChecked: PropTypes.func.isRequired,
};
